module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.form.errors.any()) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [(_vm.dismissible) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.dismiss
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), (_vm.form.errors.has('error')) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.form.errors.get('error'))
    }
  }) : _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a2aa0086!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = 20
// module chunks = 0